import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import './OpenStreetMap.css';
import React from 'react';
import Helmet from 'react-helmet';
export var defaultMapOSMState = {
  lat: 17.44212,
  lng: 78.391384,
  activeMarker: 0,
  markers: [{}]
};
export var googleMapDirectionOSMLink = function googleMapDirectionOSMLink(lat, lng) {
  return "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
};
var defaultMarker = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNC4xNjEiIGhlaWdodD0iNDMuMDY0IiB2aWV3Qm94PSIwIDAgMzQuMTYxIDQzLjA2NCI+DQogIDxnIGlkPSJub3VuX0xvY2F0aW9uXzMwMjAzNzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03Ni43NTggLTE5NC40NTgpIj4NCiAgICA8ZyBpZD0iRWxsaXBzZV8xMDMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2Ljc1OCAyMDMuOTYxKSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIGlkPSJHcm91cF81NyIgZGF0YS1uYW1lPSJHcm91cCA1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzYuNzU4IDE5NC40NTYpIj4NCiAgICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8xIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDEiIGQ9Ik0tNjQ0NC43OTItMTkwMi40M2ExLjYsMS42LDAsMCwxLTEuMTM4LS40NzEsOTcuMzcsOTcuMzcsMCwwLDEtMTAuNzEzLTEyLjMzM2MtMy40ODEtNS4wMzctNS4yMzMtOS42MjQtNS4zNTYtMTQuMDIxdi0uMDg0YTE2LjYxOSwxNi42MTksMCwwLDEsNC45NzgtMTEuMjkyLDE3LjEzOSwxNy4xMzksMCwwLDEsMTEuNzU3LTQuODYxYy4xMTgsMCwuMjM2LDAsLjM1NCwwYTE3LjUsMTcuNSwwLDAsMSwxMS44OTQsNC41NjcsMTUuNzQyLDE1Ljc0MiwwLDAsMSw1LjE3NiwxMS4ydi4wMWMuMDY5LDQuMzM0LTEuMjkyLDguNjE3LTQuMTYzLDEzLjA5M2E3OS40NzIsNzkuNDcyLDAsMCwxLTkuMDQ5LDEwLjkyNmwtLjA0NC4wNDdjLS44NzIuOTM0LTEuNjk1LDEuODE2LTIuNTA1LDIuNzA5YTEuNTkyLDEuNTkyLDAsMCwxLTEuMTUzLjUxMlptLjI5Mi0zMS41NjFhNC41LDQuNSwwLDAsMC00LjUsNC41LDQuNTA1LDQuNTA1LDAsMCwwLDQuNSw0LjUsNC41MDYsNC41MDYsMCwwLDAsNC41LTQuNUE0LjUsNC41LDAsMCwwLTY0NDQuNS0xOTMzLjk5MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0NjIgMTk0NS40OTcpIiBmaWxsPSIjMDA2N2I5Ii8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==';
var OpenStreetMap = /*#__PURE__*/function (_React$Component) {
  function OpenStreetMap() {
    var _this;
    _classCallCheck(this, OpenStreetMap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OpenStreetMap, [].concat(args));
    _this.mapRef = /*#__PURE__*/React.createRef();
    _this.IdMap = new Date().getMilliseconds();
    _this._map = void 0;
    _this.mapOSM = void 0;
    return _this;
  }
  _inherits(OpenStreetMap, _React$Component);
  return _createClass(OpenStreetMap, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var mapState = this.props.mapState;
      if (mapState === nextProps.mapState) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        callback = _this$props.callback,
        markerCallback = _this$props.markerCallback,
        customMarker = _this$props.customMarker,
        mapState = _this$props.mapState,
        zoom = _this$props.zoom;
      var setInt = setInterval(function () {
        if (typeof L === 'undefined' || !L) return;
        var layer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://openstreetmap.org/copyright" aria-label="OpenStreetMap contributors" aria-labelledby="OpenStreetMap contributors">OpenStreetMap contributors</a>'
        });
        var map = _this2.mapRef.current;
        if (!_this2.mapOSM || map != _this2._map) {
          _this2.mapOSM = L.map(map, {
            center: [mapState.lat, mapState.lng],
            zoom: zoom,
            layers: [layer]
          });
          _this2._map = map;
          callback();
        }
        clearInterval(setInt);
      }, 500);
      if (this.mapOSM && L) {
        var defaultIcon = L.icon({
          iconUrl: defaultMarker,
          iconSize: [38, 95]
        });
        if (mapState.markers && mapState.markers.length > 0) {
          if (mapState.markers[0].lat && mapState.markers[0].lng) {
            this.mapOSM.panTo(new L.LatLng(mapState.markers[0].lat, mapState.markers[0].lng));
          }
          mapState.markers.map(function (marker, index) {
            var lat = Number(marker.lat);
            var lng = Number(marker.lng);
            if (lat && lng) {
              var divIcon = L.divIcon({
                iconSize: new L.Point(0, 0),
                html: '<div class="icon-group"><span class="mml__location-icon osm-icon"></span><div class="mml__location-num osm-icon">' + Number(index + 1) + '</div></div>'
              });
              var divIconActive = L.divIcon({
                iconSize: new L.Point(0, 0),
                html: '<div class="icon-group active"><span class="mml__location-icon osm-icon"></span><div class="mml__location-num osm-icon">' + Number(index + 1) + '</div></div>'
              });
              var marker = L.marker([lat, lng], {
                icon: customMarker ? mapState.activeMarker === index ? divIconActive : divIcon : defaultIcon
              }, {
                title: 'My marker'
              }).addTo(_this2.mapOSM);
              marker.addEventListener('click', markerCallback);
            }
          });
        }
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
        rel: "stylesheet",
        href: "".concat(process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '', "/assets/styles/leaflet.css")
      }), /*#__PURE__*/React.createElement("script", {
        defer: true,
        src: "".concat(process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '', "/assets/scripts/leaflet.js")
      })), /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement("div", {
        ref: this.mapRef,
        id: "mapId_".concat(this.IdMap),
        className: "map-body",
        onLoad: callback
      })));
    }
  }]);
}(React.Component);
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles)
  }, children);
};
var commonStyles = "ckqc634";
export default OpenStreetMap;